import { RootState } from "../index";

export const isHeaderSearchSelector = (state: RootState) =>
    state.header.isSearch

export const getHeaderSearchPlaceholderSelector = (state: RootState) =>
    state.header.searchPlaceholder
